/** Nome no topo do checkout (espelha src/services/bots/checkout_identity.py). */
export const CHECKOUT_NAME_MIN = 3;
export const CHECKOUT_NAME_MAX = 25;

/** Erro para o seller, ou null. Vazio vale: o checkout usa o nome do bot. */
export function checkoutNameError(name) {
    const clean = (name || "").trim().replace(/\s+/g, " ");
    if (!clean) return null;
    if (clean.length < CHECKOUT_NAME_MIN || clean.length > CHECKOUT_NAME_MAX) {
        return `O nome do checkout deve ter entre ${CHECKOUT_NAME_MIN} e ${CHECKOUT_NAME_MAX} caracteres`;
    }
    return null;
}
